// Synchronous facade for the Sentry browser SDK. Eagerly imported from
// `src/analytics/index.ts`; intentionally contains NO dynamic imports so the
// rolldown chunk graph cannot form a cycle through Vite's __vitePreload
// runtime helper. The actual `@sentry/browser` SDK loads via `sentry-impl.ts`,
// which is dynamic-imported from the analytics bootstrap.
interface Buffered {
  err: unknown;
  context?: Record<string, unknown>;
}

let SentryModule: typeof import('@sentry/browser') | null = null;
let buffer: Buffered[] = [];

/**
 * Called by `sentry-impl.ts` once the real SDK has finished initializing.
 * Publishes the module reference and flushes the pre-init buffer.
 */
export function _setModule(m: typeof import('@sentry/browser')): void {
  SentryModule = m;
  const queued = buffer;
  buffer = [];
  for (const { err, context } of queued) m.captureException(err, { extra: context });
}

export function captureException(err: unknown, context?: Record<string, unknown>): void {
  if (!SentryModule) {
    buffer.push({ err, context });
    return;
  }
  SentryModule.captureException(err, { extra: context });
}

/** @internal — only for tests. */
export function resetForTest(): void {
  SentryModule = null;
  buffer = [];
}
